import script from "./AccountHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountHeader.vue?vue&type=script&setup=true&lang=js"

import "./AccountHeader.vue?vue&type=style&index=0&id=2122240c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2122240c"]])

export default __exports__